<script setup lang="ts">
import { useAuthUser, useGlobals } from '@/helpers/globals'
import { TgWappenSvg, ShWappenSvg } from '@/helpers/images'
import type { TeamMitglied } from '@/models/TeamMitglied'

const { app = false, teamrequests = [] } = defineProps<{
    app: boolean
    teamrequests: TeamMitglied[]
}>()

const env = useGlobals()?.config?.env
const benutzer = useAuthUser()
</script>

<template>
    <v-app-bar :app="app" class="kp-header" :class="env || ''" clipped-left extension-height="60px">
        <img :src="TgWappenSvg" height="45" alt="Thurgau Wappen" style="margin-right: 5px" />
        <img :src="ShWappenSvg" height="45" alt="Schaffhausen-Wappen" class="mr-3" />
        <v-container fluid>
            <v-row justify="space-between" align="center">
                <v-col>
                    <div class="d-none d-sm-block" style="min-width: 340px">
                        <h1 class="title">
                            {{ $t('g_efp') }}
                        </h1>
                        <div class="subtitle">
                            {{ $t('k_tg_sh') }}
                        </div>
                    </div>
                </v-col>
                <v-spacer />
                <v-col cols="auto" style="text-align: end">
                    <slot></slot>
                </v-col>
            </v-row>
        </v-container>
        <template v-slot:extension>
            <v-tabs show-arrows icons-and-text class="topnav" active-class="kp-main-tabs-active">
                <v-tab :to="{ name: 'home' }" exact>
                    <span class="d-none d-sm-flex">
                        {{ $t('home') }}
                    </span>
                    <v-icon dense>fas fa-home fa-xs</v-icon>
                </v-tab>
                <v-tab :to="{ name: 'gesuche' }">
                    <span class="d-none d-sm-flex">
                        {{ $t('gesuche') }}
                    </span>
                    <v-icon dense>fas fa-balance-scale fa-fw</v-icon>
                </v-tab>
                <v-tab :to="{ name: 'adressen' }">
                    <span class="d-none d-sm-flex">
                        {{ $t('adressen') }}
                    </span>
                    <v-icon dense>fas fa-address-book fa-fw</v-icon>
                </v-tab>
                <v-tab :to="{ name: 'liegenschaften' }">
                    <span class="d-none d-sm-flex">
                        {{ $t('liegenschaften') }}
                    </span>
                    <v-icon dense>fas fa-building fa-fw</v-icon>
                </v-tab>

                <v-tab :to="{ name: 'teams' }">
                    <v-badge
                        color="error"
                        overlap
                        :value="teamrequests ? teamrequests.length : 0"
                        :content="teamrequests ? teamrequests.length : 0"
                    >
                        <v-icon dense>fas fa-users fa-fw</v-icon>
                        <span class="d-none d-sm-flex">
                            {{ $t('teams') }}
                        </span>
                    </v-badge>
                </v-tab>
                <v-tab v-if="benutzer?.rolle === 'admin'" :to="{ name: 'news' }">
                    <span class="d-none d-sm-flex">
                        {{ $t('news') }}
                    </span>
                    <v-icon dense>fas fa-rss fa-fw</v-icon>
                </v-tab>
                <v-tab v-if="benutzer?.rolle === 'admin'" :to="{ name: 'hilfetexte' }">
                    <span class="d-none d-sm-flex">
                        {{ $t('hilfetexte') }}
                    </span>
                    <v-icon dense>fas fa-circle-question fa-fw</v-icon>
                </v-tab>
            </v-tabs>
        </template>
    </v-app-bar>
</template>
<style lang="scss" scoped>
.topnav {
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;

    .v-tab {
        font-size: 16px;

        &:not(.v-tab--active) {
            color: black !important;
        }

        .v-tab--active {
            .v-icon {
                // color: #888;
            }
        }
    }
}
</style>
